import { render, staticRenderFns } from "./WeekFastNewsListItem.vue?vue&type=template&id=fc76cd22&scoped=true"
import script from "./WeekFastNewsListItem.vue?vue&type=script&lang=js"
export * from "./WeekFastNewsListItem.vue?vue&type=script&lang=js"
import style0 from "./WeekFastNewsListItem.vue?vue&type=style&index=0&id=fc76cd22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc76cd22",
  null
  
)

export default component.exports